/*
 *   Utilities for working with Firebase Firestore
 *
 *   This replaces the old Firefly "models" (wrappers around Firebase RTDB).
 *   This means we can use Firebase directly in models, with no abstraction,
 *   but still keep methods for handling data DRY.
 *   No more eventemitter to do the same thing Firebase was already doing!
 *   "Composition over Inheritance"!
 *   Also keeps our codebase smaller and complexity lower.
 */

const Firebase = require('firebase')

// GETTERS
// all items that come back from a query have "key" attributes

// get a single document from a query
const getDocFromQuery = snapshot => {
  if (!snapshot.docs) {
    return null
  }
  let doc = snapshot.docs[0].data()
  doc.id = snapshot.docs[0].id
  return doc
}

// get a single document from a .doc() call
const getDocFromDoc = snapshot => {
  if (!snapshot.exists) {
    return null
  }
  let doc = snapshot.data()
  doc.id = snapshot.id
  return doc
}

// get a many documents from a snapshot
const getDocsFromQuery = snapshot => {
  return snapshot.docs.map( snap => {
    const doc = snap.data()
    doc.id = snap.id
    return doc
  })
}

// SETTERS
// adds timestamps and saves which user created/updated

const prepareForCreate = doc => {

  // timestamps
  doc.createdBy = Firebase.auth().currentUser ? Firebase.auth().currentUser.uid : null
  doc.createdOn = new Date()

  return doc
}

const prepareForUpdate = doc => {

  // timestamps
  doc.updatedBy = Firebase.auth().currentUser ? Firebase.auth().currentUser.uid : null
  doc.updatedOn = new Date()

  // ensure we're not trying to write the key as part of the document
  delete doc.id

  // ensure we're not writing derived attrs (attrs that start with "_")
  Object.keys(doc).forEach( key => {
    if (key.indexOf('_') === 0) {
      delete doc[key]
    }
  })

  return doc
}

export {
  getDocFromDoc,
  getDocFromQuery,
  getDocsFromQuery,
  prepareForCreate,
  prepareForUpdate,
}



// WEBPACK FOOTER //
// ./src/data/db_util.js